import React, { useEffect, useMemo, useRef, useState } from "react";
import ICVActivitesTab from "./ICVActivitiesTab";
import ICVTableComponent from "../../../components/ICVTableComponents";
import { useDispatch, useSelector } from "react-redux";
import ICVFormDetails from "./ICVFormDetails";// Assuming these hooks are created for dispatch and selector
import { getICVDownloadCSV, getICVInfoAPICall, getICVPolicyReport } from "../../../api/icvActivityAPI";
import { ICVFilterTYpe } from "../../../models/ICVActivitiesModels";
import { DEFAULT_OPTION, PAGINATION_OPTIONS } from "../../../utils/Constant";
import { dateConverter, dateConverterWithoutAddingDays } from "../../../utils/Util";
import { handleICVActivitiesPaginationDataSlice } from "../../../redux/slices/globalSlice";
import { handleICVGetDownLoadCSVDataSlice, handleICVGetInfoDataSlice, handleICVGetPolicyReportDataSlice } from "../../../redux/slices/icvActivitySlice";
import ReactPaginate from "react-paginate";
import { Button, Col, Input, Row } from "reactstrap";
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import ICVPagination from "../../../components/ICVPagination";
import moment from "moment";
import DownloadIcon from "../../../assets/img/download.svg";
import { toast } from "react-toastify";
import { LoggedUserType } from "../../../models/GlobalModels";
import { loginSelector } from "../../../redux/slices/loginSlice";
import SearchBox from "../../../components/SearchBox";
import { IconButton } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import CPagination from "../../../components/CPagination";
const PageSize = 5;

const ICVActivities: React.FC = () => {
  const dispatch: any = useDispatch();
  const user: LoggedUserType = useSelector(loginSelector).user;
  const { storeICVActivitiesPaginationData } = useSelector((state: any) => state.global);
  const { storeICVGetInfoData, isLoading, storeICVGetPolicyReportData, storeICVGetDownLoadCSVData } = useSelector((state: any) => state.icvActivity);
  const updatePageStore = useSelector((state: any) => state.global);
  const [formData, setFormData] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterData, setFilterData] = useState<any[]>([]);// 
  // Assuming formData is an array
  const [surveyorData, setSurveyorData] = useState<any>(""); // Adjust surveyorData type accordingly
  const [search, setSearch] = useState<string>('');
  const { limit, offset, selectedLimit } = storeICVActivitiesPaginationData;
  const [icvData, setIcvData] = useState(storeICVGetInfoData);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const hasMadeInitialCall = useRef(false);

  const defaultFilters: ICVFilterTYpe = {
    state: DEFAULT_OPTION,
    district: DEFAULT_OPTION,
    mandal: DEFAULT_OPTION,
    cropVillage: [],
    season: DEFAULT_OPTION,
    cropId: [],
    year: DEFAULT_OPTION,
    fromDate: moment(new Date)?.subtract('1', 'months')?.toDate(),
    patwarName: [],
    toDate: undefined,
    kmlId: ''
  };

  const [selectedFilter, setSelectedFilter] = useState<ICVFilterTYpe>(defaultFilters);

  const changePaginationLimit = (value: number) => {
    if (icvData?.data?.length > 0) {
      dispatch(
        handleICVActivitiesPaginationDataSlice({
          ...storeICVActivitiesPaginationData,
          offset: 0,
          limit: value,
          selectedLimit: value,
        })
      );
    }
  };

  const prevPage = () => {
    const newOffset = storeICVActivitiesPaginationData.offset - storeICVActivitiesPaginationData.selectedLimit;
    if (newOffset >= 0) {
      const newLimit = storeICVActivitiesPaginationData.selectedLimit;
      dispatch(
        handleICVActivitiesPaginationDataSlice({
          ...storeICVActivitiesPaginationData,
          offset: newOffset,
          limit: newLimit,
        })
      );
    }
  };

  const nextPage = () => {
    const count = storeICVActivitiesPaginationData.selectedLimit;
    if (icvData.count > 0 && icvData.count === count) {
      dispatch(
        handleICVActivitiesPaginationDataSlice({
          ...storeICVActivitiesPaginationData,
          offset: storeICVActivitiesPaginationData.offset + storeICVActivitiesPaginationData.selectedLimit,
          limit: storeICVActivitiesPaginationData.selectedLimit,
        })
      );
    }
  };

  useEffect(() => {
    // Skip on initial load or if we haven't made the initial call yet
    if (isInitialLoad || !hasMadeInitialCall.current) return;
      getCompletedICVData();
  },[
    storeICVActivitiesPaginationData.selectedLimit,
    storeICVActivitiesPaginationData.offset,
  ]);

  useEffect(() => {
    if (isInitialLoad) {
      setIsInitialLoad(false);
      return;
    }
  }, [
    selectedFilter
  ]);  
  
  useEffect(() => {
    const hasExistingData = storeICVGetInfoData?.data && storeICVGetInfoData.data.length > 0;
    if (isInitialLoad && !hasMadeInitialCall.current) {
      hasMadeInitialCall.current = true;
      setIsInitialLoad(false);
    }
  }, []);

  useEffect(() => {
    return () => {
      setIsInitialLoad(true);
      hasMadeInitialCall.current = false;
    };
  }, []);

  const getCompletedICVData = () => {
    getCompletedICVDataWithFilters(selectedFilter);
  }

  const getCompletedICVDataWithFilters = (filters: ICVFilterTYpe) => {
    dispatch(
      getICVInfoAPICall(
        limit,
        offset,
        filters?.state?.value,
        filters?.district?.value,
        filters?.mandal?.value,
        filters?.patwarName,
        filters?.cropVillage,
        filters?.season?.value,
        filters?.cropId,
        filters?.year?.value,
        filters?.fromDate
          ? dateConverterWithoutAddingDays(filters?.fromDate?.toString(), "fromDate")
          : undefined,
        filters?.toDate
          ? dateConverterWithoutAddingDays(filters?.toDate?.toString(), "toDate")
          : undefined,
        user?.emailId,
        user?.roleId,
        filters?.kmlId
      )
    );
  }

  const handleApplyFilters = (filters: ICVFilterTYpe, shouldCallAPI: boolean = true) => {
    setFormData([]);
    setSelectedFilter(filters); // Update selectedFilter state
    
    // If shouldCallAPI is false (reset case), clear data and don't call API
    if (!shouldCallAPI) {
      // Clear the data by dispatching an empty data slice
      dispatch(handleICVGetInfoDataSlice({ data: [], count: 0 }));
      return;
    }
    
    // Only reset pagination when filters change, don't call API automatically
    if(storeICVActivitiesPaginationData.offset > 0) {
      dispatch(
        handleICVActivitiesPaginationDataSlice({
          ...storeICVActivitiesPaginationData,
          offset: 0,
        })
      );
      
      return;
    }
    
    // For submit case, always call API with the new filters directly
    getCompletedICVDataWithFilters(filters);
  };

  const viewForm = (storeICVGetInfoData: any, surveyorDetails: any) => {
    const userObject = {
      ...storeICVGetInfoData,
      surveyorDetails: surveyorDetails,
    };

    setSurveyorData(surveyorDetails);
    setFormData(userObject);
  };
  const handleSearch = () => {

    setSearch(searchQuery);
  };
  
  // Slice the data based on the pagination offset and limit
  const paginatedData = useMemo(() => {
    setIcvData(storeICVGetInfoData)
    let filterData = storeICVGetInfoData?.data
    if (filterData) {
      if (search?.length > 0) {
        filterData = filterData?.filter((item: any) => {
          return (
            item.surveyorMobileNumber
              ?.toLowerCase()
              .includes(searchQuery.toLowerCase()?.trim()) ||
            item.ncipApplicationId
              ?.toLowerCase()
              .includes(searchQuery.toLowerCase()?.trim())
          );
        });
        let data = {...storeICVGetInfoData, count: filterData.length}
        setIcvData(data)
      }      
      setFilterData(filterData);
      return filterData;
    }
    return [];
  }, [storeICVGetInfoData, search, storeICVActivitiesPaginationData, selectedFilter]);

  //function to handle download ICV Report
  const downloadExcel = () => {
    if (
      selectedFilter.state.value ||
      selectedFilter.district.value ||
      selectedFilter.mandal.value ||
      selectedFilter.cropVillage ||
      selectedFilter.season.value ||
      selectedFilter.cropId ||
      (selectedFilter.fromDate && selectedFilter.toDate) ||
      selectedFilter.year.value
    ) {
      dispatch(
        getICVDownloadCSV(
          selectedFilter.state.value,
          selectedFilter.district.value,
          selectedFilter.mandal.value,
          selectedFilter.cropVillage,
          selectedFilter.season.value,
          selectedFilter.cropId,
          selectedFilter.fromDate !== undefined
            ? dateConverterWithoutAddingDays(
              selectedFilter.fromDate?.toString(),
              "fromDate"
            )
            : undefined,
          selectedFilter.toDate !== undefined
            ? dateConverterWithoutAddingDays(
              selectedFilter.toDate?.toString(),
              "toDate"
            )
            : undefined,
          selectedFilter.year.value,
          user?.emailId,
          user?.roleId
        )
      );
    } else {
      toast.error("Select Filters to view the map");
    }
  };

  useEffect(() => {
    if (
      storeICVGetDownLoadCSVData.statusCode === 1 &&
      storeICVGetDownLoadCSVData.data
    ) {
      const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${storeICVGetDownLoadCSVData.data}`;
      const downloadLink = document.createElement("a");
      const fileName = `ICV_REPORT_${Date.now()}.xlsx`;

      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      toast.success("File Downloaded Successfully");
      dispatch(handleICVGetDownLoadCSVDataSlice({}));
    }
  }, [storeICVGetDownLoadCSVData.statusCode === 1]);

  //function to download ICV policy Report

  const icvPolicyReport = () => {
    if (
      selectedFilter.state.value ||
      selectedFilter.district.value ||
      selectedFilter.mandal.value ||
      selectedFilter.cropVillage ||
      selectedFilter.season.value ||
      selectedFilter.cropId ||
      (selectedFilter.fromDate && selectedFilter.toDate) ||
      selectedFilter.year.value
    ) {
      dispatch(
        getICVPolicyReport(
          selectedFilter.state.value,
          selectedFilter.district.value,
          selectedFilter.mandal.value,
          selectedFilter.cropVillage,
          selectedFilter.season.value,
          selectedFilter.cropId,
          selectedFilter.fromDate !== undefined
            ? dateConverterWithoutAddingDays(
              selectedFilter.fromDate?.toString(),
              "fromDate"
            )
            : undefined,
          selectedFilter.toDate !== undefined
            ? dateConverterWithoutAddingDays(
              selectedFilter.toDate?.toString(),
              "toDate"
            )
            : undefined,
          selectedFilter.year.value,
          user?.emailId,
          user?.roleId
        )
      );
    } else {
      toast.error("Select Filters to view the map");
    }
  };

  useEffect(() => {
    if (
      storeICVGetPolicyReportData.statusCode === 1 &&
      storeICVGetPolicyReportData.data
    ) {
      const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${storeICVGetPolicyReportData.data}`;
      const downloadLink = document.createElement("a");
      const fileName = `ICV_POLICY_REPORT_${Date.now()}.xlsx`;

      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      toast.success("File Downloaded Successfully");
      dispatch(handleICVGetPolicyReportDataSlice({}));
    }
  }, [storeICVGetPolicyReportData.statusCode === 1]);

  return (
    <>
      {isLoading &&
        <CircleSpinnerOverlay
          loading={isLoading}
          overlayColor="rgba(147, 166, 199, 0.1)"
          color="#5C79AA"
          zIndex={9999}
        />}
      {updatePageStore.updatePageStore ? (
        <ICVFormDetails storeICVFormData={formData} />
      ) : (
        <>
          <div>
              <Row className="mb-2 justify-content-between">
                <Col className="px-3" md={4}>
                  <SearchBox
                      placeHolder="Search with Surveyor Mobile No. or Application No."
                      value={searchQuery}
                      onChange={(e: any) => setSearchQuery(e.target.value)}
                      icon={
                        <IconButton
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            zIndex: '999'
                          }}
                          onClick={() => handleSearch()}
                        >
                          <SearchIcon />
                        </IconButton>
                      }
                  />
                </Col>
                <Col xs="auto" className="d-flex px-2">
                  {user?.permissions?.includes('Download-ICV-Report') ? (
                    <div>
                      <Button
                        variant="outline-primary"
                        className="mx-2 cl-btn-outline-primary"
                        onClick={() => {
                          downloadExcel();
                        }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px'
                        }}
                      >
                        ICV Report
                        <img
                          src={DownloadIcon}
                          alt="Download"
                          style={{
                            width: '16px',
                            height: '16px',
                            filter: 'brightness(0) saturate(100%) invert(31%) sepia(15%) saturate(1234%) hue-rotate(189deg) brightness(95%) contrast(89%)',
                            transition: 'filter 0.2s ease'
                          }}
                        />
                      </Button>
                    </div>
                  ) : (
                    <></>
                  )}
                  {user?.permissions?.includes('Download-ICV-Policy-Report') ? (
                    <div>
                      <Button
                        variant="outline-primary"
                        className="mx-2 cl-btn-outline-primary"
                        onClick={() => {
                          icvPolicyReport();
                        }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px'
                        }}
                      >
                        ICV policy details report
                        <img
                          src={DownloadIcon}
                          alt="Download"
                          style={{
                            width: '16px',
                            height: '16px',
                            filter: 'brightness(0) saturate(100%) invert(31%) sepia(15%) saturate(1234%) hue-rotate(189deg) brightness(95%) contrast(89%)',
                            transition: 'filter 0.2s ease'
                          }}
                        />
                      </Button>
                    </div>
                  ) : (
                    <></>
                  )}
                </Col>
              </Row>
            <ICVActivitesTab onApplyFilters={handleApplyFilters} search={search} setSearch={setSearch} setSearchQuery={setSearchQuery}/>
            <div
              style={{ marginTop: 20, overflowX: "hidden", maxWidth: "100%" }}
            >
              {paginatedData.length > 0 ? (
                <ICVTableComponent
                  viewForm={viewForm}
                  ICVDashboardData={paginatedData} // Use paginated data
                />
              ) : (
                <div 
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '60px 20px',
                    margin: '20px 0'
                  }}
                >
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '14px', fontWeight: 'bold' }}>
                      Please apply appropriate filters and submit to view the surveys
                    </div>
                  </div>
                </div>
              )}
            </div>
            <CPagination
              storeCHMDashboardData={icvData}
              storeCHMPaginationData={storeICVActivitiesPaginationData}
              changePaginationLimit={changePaginationLimit}
              paginationLimitOptions={PAGINATION_OPTIONS.COMPLETED_ICV}
              nextPage={nextPage}
              prevPage={prevPage}
              showTotalCount={false}
              showHelper={true}
              helperText={`Use the 'Next(≫)' and 'Previous(≪)' buttons to browse through more data.`}
            />
          </div>
        </>
      )}

    </>
  );
};

export default ICVActivities;
